import React from "react";
import { NavLink } from "react-router-dom";
import "./SubNav.css";

const SubNav = () => {
  return (
    <div className="subnav__content">
      <nav className="subnav">
        <ul className="sub__list">
          <li className="sub__item">
            <NavLink className="link sub__link" to="/dashborad/foods">
              Foods
            </NavLink>
          </li>
          <li className="sub__item">
            <NavLink className="link sub__link " to="/dashborad/users">
              Users
            </NavLink>
          </li>
          <li className="sub__item">
            <NavLink className="link sub__link" to="/dashborad/orders">
              Orders
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default SubNav;
